"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSideBySideBehaviours = void 0;
var BehaviourBuilder_1 = require("../BehaviourBuilder");
var EditorTypes_1 = require("../../EditorTypes");
var Types_1 = require("@CommonFrontendBackend/ContentTokens/Types");
var SideBySideActions_1 = require("./SideBySideActions");
var QwilrEditorTelemetry_1 = require("Project/QwilrEditor/QwilrEditorTelemetry");
var TelemetryParameterValue_1 = require("Telemetry/TelemetryParameterValue");
var WidgetActions = __importStar(require("../WidgetActions"));
var BehaviourNames = Object.freeze({
    AddSideBySide: "addSideBySide",
    DeleteSideBySide: "deleteSideBySide",
    SetPercentage: "setPercentageForSideBySide",
    SetWidth: "setWidthForSideBySide",
    SelectSideBySide: "selectSideBySide",
    DeselectSideBySide: "deselectSideBySide",
    DismissPlaceholder: "dismissSideBySidePlaceholder",
    PickImage: "pickSideBySideImage",
    EmbedImage: "embedSideBySideImage",
    OnBackspace: "onBackspaceRemoveSelectedSideBySides",
    OnEnter: "onEnterInsertParagraphBelowSideBySide",
    UpdateSideBySideSelection: "updateSideBySideSelection",
    SwapOrder: "swapOrderForSideBySide",
    OnComma: "onCommaReduceWidthSideBySide",
    OnPeriod: "onPeriodIncreaseWidthSideBySide",
});
var getSideBySideBehaviours = function (di, router) {
    var telemetry = di.get("editorTelemetry");
    return {
        onSideBySideDelete: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourNames.DeleteSideBySide)
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: Types_1.WidgetBlockType.SideBySide, action: EditorTypes_1.SideBySideActionType.DeleteSideBySide })
            .doAction(function (event, editor) {
            telemetry.inlineContentDeleted(EditorTypes_1.BlockType.SideBySide);
            WidgetActions.removeWidget(editor, event.data.path);
            return true;
        }),
        onChangeSideBySidePercentage: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourNames.SetPercentage)
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: Types_1.WidgetBlockType.SideBySide, action: EditorTypes_1.SideBySideActionType.SetPercentage })
            .doAction(function (event, editor) {
            var _a = event.data, path = _a.path, percentage = _a.percentage;
            telemetry.inlineContentResized(EditorTypes_1.BlockType.SideBySide, {
                columnsSize: percentage,
            });
            (0, SideBySideActions_1.setSideBySidePercentage)(editor, percentage, path);
            return true;
        }),
        onSwapOrderForSideBySide: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourNames.SwapOrder)
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: Types_1.WidgetBlockType.SideBySide, action: EditorTypes_1.SideBySideActionType.SwapOrder })
            .doAction(function (event, editor) {
            (0, SideBySideActions_1.swapSideBySideOrder)(editor, event.data.path);
            telemetry.columnsSwappedInSideBySide();
            return true;
        }),
        onChangeSideBySideWidth: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourNames.SetWidth)
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: Types_1.WidgetBlockType.SideBySide, action: EditorTypes_1.SideBySideActionType.SetWidth })
            .doAction(function (event, editor) {
            (0, SideBySideActions_1.setSideBySideWidth)(editor, event.data.width, event.data.path);
            telemetry.sideBySideResized(event.data.width, QwilrEditorTelemetry_1.SideBySideResizeOrigin.Mouse);
            return true;
        }),
        onSelectSideBySideWidget: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourNames.SelectSideBySide)
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: Types_1.WidgetBlockType.SideBySide, action: EditorTypes_1.SideBySideActionType.SelectSideBySide })
            .doAction(function (event, editor) {
            (0, SideBySideActions_1.selectSideBySideWidget)(editor, event.data.path);
            return true;
        }),
        onDeselectSideBySideWidget: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourNames.DeselectSideBySide)
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: Types_1.WidgetBlockType.SideBySide, action: EditorTypes_1.SideBySideActionType.DeselectSideBySide })
            .doAction(function (event, editor) {
            (0, SideBySideActions_1.deselectSideBySideWidget)(editor, event.data.path);
            return true;
        }),
        onDismissSideBySidePlaceholder: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourNames.DismissPlaceholder)
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: Types_1.WidgetBlockType.SideBySide, action: EditorTypes_1.SideBySideActionType.DismissPlaceholder })
            .doAction(function (event, editor) {
            telemetry.inlineContentPlaceholderDeleted(QwilrEditorTelemetry_1.InlineContentPlaceholderType.Columns);
            (0, SideBySideActions_1.dismissSideBySidePlaceholder)(editor, event.data.path);
            return true;
        }),
        onUploadImage: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourNames.PickImage)
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: Types_1.WidgetBlockType.SideBySide, action: EditorTypes_1.SideBySideActionType.PickImage })
            .doAction(function (event, editor) {
            var path = event.data.path;
            (0, SideBySideActions_1.sideBySidePickImage)(editor, router, di, path);
            return true;
        }),
        onEmbedImage: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourNames.EmbedImage)
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: Types_1.WidgetBlockType.SideBySide, action: EditorTypes_1.SideBySideActionType.EmbedImage })
            .doAction(function (event, editor) {
            var _a = event.data, imageData = _a.imageData, path = _a.path;
            (0, SideBySideActions_1.sideBySideEmbedImage)(editor, path, imageData);
            telemetry.sideBySideContentAdded(TelemetryParameterValue_1.ContentAddedType.Image);
            return true;
        }),
        onBackspaceRemoveSelectedSideBySides: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourNames.OnBackspace)
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Backspace)
            .doAction(function (event, editor) {
            var trackSideBySideDeletion = function () {
                telemetry.inlineContentDeleted(EditorTypes_1.BlockType.SideBySide);
            };
            var shouldSuppressFurtherDeletion = (0, SideBySideActions_1.removeSelectedSideBySides)(editor, trackSideBySideDeletion);
            if (shouldSuppressFurtherDeletion) {
                event.preventDefault();
            }
            return shouldSuppressFurtherDeletion || undefined;
        }),
        onEnterInsertParagraphBelow: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourNames.OnEnter)
            .inBlockType(EditorTypes_1.BlockType.SideBySideDummy)
            .selectionIsCollapsed()
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Enter)
            .doAction(function (event, editor) {
            event.preventDefault();
            (0, SideBySideActions_1.insertParagraphBelowSideBySide)(editor);
            return true;
        }),
        onCommaReduceWidthSideBySide: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourNames.OnComma)
            .inBlockType(EditorTypes_1.BlockType.SideBySideDummy)
            .selectionIsCollapsed()
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Comma)
            .doAction(function (event, editor) {
            event.preventDefault();
            (0, SideBySideActions_1.reduceWidthOfSideBySide)(editor, telemetry);
            return true;
        }),
        onPeriodIncreaseWidthSideBySide: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourNames.OnPeriod)
            .inBlockType(EditorTypes_1.BlockType.SideBySideDummy)
            .selectionIsCollapsed()
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Period)
            .doAction(function (event, editor) {
            event.preventDefault();
            (0, SideBySideActions_1.increaseWidthOfSideBySide)(editor, telemetry);
            return true;
        }),
        onUpdateSideBySideSelection: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourNames.UpdateSideBySideSelection)
            .isEvent(EditorTypes_1.EventType.Selection)
            .doAction(function (event, editor) {
            return (0, SideBySideActions_1.updateSideBySideSelection)(editor);
        }),
    };
};
exports.getSideBySideBehaviours = getSideBySideBehaviours;
